import React from 'react';
import { motion } from 'framer-motion';
interface SlideProps {
  index: number;
  total: number;
}
export function SlideCampaignFlow({
  index
}: SlideProps) {
  return <div className="relative w-screen h-screen overflow-hidden bg-white p-[clamp(2rem,4vw,4rem)] flex flex-col" data-id="element-381">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.2,
      duration: 0.6
    }} className="mb-[clamp(1.5rem,2.5vw,2.5rem)] flex-shrink-0 text-center" data-id="element-382">
        <h2 className="text-[var(--fg)] font-bold text-[clamp(2rem,3.6vw,3.25rem)] leading-[1.08]" data-id="element-383">
          Leo Example Campaign
        </h2>
      </motion.div>

      <div className="flex-1 flex items-center justify-center min-h-0" data-id="element-384">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.4,
        duration: 0.5
      }} className="w-full h-full max-w-6xl relative" data-id="element-385">
          <img src="https://cdn.magicpatterns.com/uploads/wWheb1ahK2YTaF9M2yD9Va/Screenshot_2026-06-29_at_11.23.35.png" alt="Campaign Flow Diagram" className="w-full h-full object-contain" data-id="element-386" />
        </motion.div>
      </div>
    </div>;
}